import keyMirror from 'keymirror'

export default keyMirror({
  // HEADER
  SET_ACTIVE_HEADER_KEY: null,
  SET_NEXT_CLICKED: null,
  SET_SHOW_EXIT_MODAL: null,
  SET_EXIT_MODAL: null,
  // AUTH
  FHIR_SMART_INITIALIZE: null,
  FHIR_GET_METADATA: null,
  FHIR_GET_METADATA_FAILED: null,
  FHIR_GET_METADATA_SUCCEEDED: null,
  FHIR_ACCESS_TOKEN_RECEIVED: null,
  FHIR_ERROR: null,
  FHIR_GENERATE_TOKEN_URI_REQUESTED: null,
  FHIR_GENERATE_TOKEN_URI_FULFILLED: null,
  FHIR_GENERATE_TOKEN_URI_REJECTED: null,
  GET_ACCESS_TOKEN_REQUESTED: null,
  GET_ACCESS_TOKEN_FULFILLED: null,
  GET_ACCESS_TOKEN_REJECTED: null,
  // HEALTH SYSTEM
  GET_HEALTH_SYSTEMS_REQUESTED: null,
  GET_HEALTH_SYSTEMS_FULFILLED: null,
  GET_HEALTH_SYSTEMS_REJECTED: null,
  GET_HEALTH_SYSTEM_REQUESTED: null,
  GET_HEALTH_SYSTEM_FULFILLED: null,
  GET_HEALTH_SYSTEM_REJECTED: null,
  CREATE_HEALTH_SYSTEM_REQUESTED: null,
  CREATE_HEALTH_SYSTEM_FULFILLED: null,
  CREATE_HEALTH_SYSTEM_REJECTED: null,
  GET_HEALTH_SYSTEM_USERS_REQUESTED: null,
  GET_HEALTH_SYSTEM_USERS_FULFILLED: null,
  GET_HEALTH_SYSTEM_USERS_REJECTED: null,
  GET_HEALTH_SYSTEM_RULES_REQUESTED: null,
  GET_HEALTH_SYSTEM_RULES_FULFILLED: null,
  GET_HEALTH_SYSTEM_RULES_REJECTED: null,
  UPDATE_HEALTH_SYSTEM_RULE_REQUESTED: null,
  UPDATE_HEALTH_SYSTEM_RULE_FULFILLED: null,
  UPDATE_HEALTH_SYSTEM_RULE_REJECTED: null,
  GET_HEALTH_SYSTEM_ACTIONS_REQUESTED: null,
  GET_HEALTH_SYSTEM_ACTIONS_FULFILLED: null,
  GET_HEALTH_SYSTEM_ACTIONS_REJECTED: null,
  SORT_HEALTH_SYSTEM_ACTIONS: null,
  CREATE_HEALTH_SYSTEM_ACTION_REQUESTED: null,
  CREATE_HEALTH_SYSTEM_ACTION_FULFILLED: null,
  CREATE_HEALTH_SYSTEM_ACTION_REJECTED: null,
  UPDATE_ACTION_ORDER: null,
  UPDATE_HEALTH_SYSTEM_ACTION_REQUESTED: null,
  UPDATE_HEALTH_SYSTEM_ACTION_FULFILLED: null,
  UPDATE_HEALTH_SYSTEM_ACTION_REJECTED: null,
  DELETE_HEALTH_SYSTEM_ACTION_REQUESTED: null,
  DELETE_HEALTH_SYSTEM_ACTION_FULFILLED: null,
  DELETE_HEALTH_SYSTEM_ACTION_REJECTED: null,
  ADD_RULE_ACTION_REQUESTED: null,
  ADD_RULE_ACTION_FULFILLED: null,
  ADD_RULE_ACTION_REJECTED: null,
  DELETE_RULE_ACTION_REQUESTED: null,
  DELETE_RULE_ACTION_FULFILLED: null,
  DELETE_RULE_ACTION_REJECTED: null,
  RESEND_SETUP_REQUESTED: null,
  RESEND_SETUP_FULFILLED: null,
  RESEND_SETUP_REJECTED: null,
  GET_CONTENT_REQUESTED: null,
  GET_CONTENT_FULFILLED: null,
  GET_CONTENT_REJECTED: null,
  RESET_HEALTH_SYSTEM_USER_STATE: null,
  RESET_HEALTH_SYSTEM_RULE_STATE: null,
  RESET_HEALTH_SYSTEM_ORDER_STATE: null,
  GET_REPORT_REQUESTED: null,
  GET_REPORT_FULFILLED: null,
  GET_REPORT_REJECTED: null,
  // PATIENT
  GET_PATIENT_REQUESTED: null,
  GET_PATIENT_FULFILLED: null,
  GET_PATIENT_REJECTED: null,
  GET_ENCOUNTER_REQUESTED: null,
  GET_ENCOUNTER_FULFILLED: null,
  GET_ENCOUNTER_REJECTED: null,
  START_ENCOUNTER_OVER_REQUESTED: null,
  START_ENCOUNTER_OVER_FULFILLED: null,
  START_ENCOUNTER_OVER_REJECTED: null,
  GET_PATIENT_CONDITIONS_REQUESTED: null,
  GET_PATIENT_CONDITIONS_FULFILLED: null,
  GET_PATIENT_CONDITIONS_REJECTED: null,
  GET_PATIENT_MEDICATIONS_REQUESTED: null,
  GET_PATIENT_MEDICATIONS_FULFILLED: null,
  GET_PATIENT_MEDICATIONS_REJECTED: null,
  GET_PATIENT_PROCEDURES_REQUESTED: null,
  GET_PATIENT_PROCEDURES_FULFILLED: null,
  GET_PATIENT_PROCEDURES_REJECTED: null,
  GET_PATIENT_OBSERVATIONS_REQUESTED: null,
  GET_PATIENT_OBSERVATIONS_FULFILLED: null,
  GET_PATIENT_OBSERVATIONS_REJECTED: null,
  UPDATE_ENCOUNTER_STATUS: null,
  SET_PATIENT_DATA: null,
  RESET_PATIENT_REQUESTED: null,
  RESET_PATIENT_FULFILLED: null,
  RESET_PATIENT_REJECTED: null,
  // ASSESSMENT
  GET_ASSESSMENT_ITEMS_REQUESTED: null,
  GET_ASSESSMENT_ITEMS_FULFILLED: null,
  GET_ASSESSMENT_ITEMS_REJECTED: null,
  SET_ASSESSMENT_FETCHING: null,
  SET_ASSESSMENT_ERROR: null,
  SET_ASSESSMENT_ENCOUNTER: null,
  SET_ASSESSMENT_PGA: null,
  UPDATE_ASSESSMENT_S2K: null,
  UPDATE_ASSESSMENT_FLARE: null,
  SET_ASSESSMENT_NO_FLARE: null,
  RESET_ASSESSMENT_FLARE: null,
  UPDATE_ASSESSMENT_LLDAS: null,
  RESET_ASSESSMENT_LLDAS: null,
  UPDATE_ASSESSMENT_DAMAGE: null,
  SET_ASSESSMENT_NO_DAMAGE_INDEX: null,
  RESET_ASSESSMENT_DAMAGE: null,
  SAVE_ASSESSMENT_REQUESTED: null,
  SAVE_ASSESSMENT_FULFILLED: null,
  SAVE_ASSESSMENT_REJECTED: null,
  CLEAR_ASSESSMENT: null,
  EXIT_ASSESSMENT: null,
  SET_ASSESSMENT_MEDICATIONS: null,
  GET_ASSESSMENT_FULFILLED: null,
  SET_PEND_S2K: null,
  // CARE PLAN,
  SET_CAREPLAN_REQUESTED: null,
  SET_CAREPLAN_FULFILLED: null,
  SET_CAREPLAN_REJECTED: null,
  UPDATE_CAREPLAN_OPPORTUNITY: null,
  UPDATE_CAREPLAN_RULE: null,
  UPDATE_CAREPLAN_ACTION: null,
  UPDATE_CAREPLAN_SUB_ACTION: null,
  SAVE_CAREPLAN_REQUESTED: null,
  SAVE_CAREPLAN_FULFILLED: null,
  SAVE_CAREPLAN_REJECTED: null,
  CLEAR_CAREPLAN: null,
  GET_CAREPLAN_FULFILLED: null,
  // WRAP UP
  SET_WRAP_UP: null,
  UPDATE_WRAP_UP_ACTION: null,
  SAVE_WRAP_UP_REQUESTED: null,
  SAVE_WRAP_UP_FULFILLED: null,
  SAVE_WRAP_UP_REJECTED: null,
  CLEAR_WRAP_UP: null,
  CREATE_WRAP_UP_NOTE: null,
  UPDATE_WRAP_UP_NOTE: null,
  CREATE_ASSEMBLED_NOTE_REQUESTED: null,
  CREATE_ASSEMBLED_NOTE_FULFILLED: null,
  CREATE_ASSEMBLED_NOTE_REJECTED: null,
  UPDATE_ASSEMBLED_NOTE: null,
  CREATE_APPOINTMENT_REQUESTED: null,
  CREATE_APPOINTMENT_FULFILLED: null,
  CREATE_APPOINTMENT_REJECTED: null,
  CREATE_DOCUMENT_REQUESTED: null,
  CREATE_DOCUMENT_FULFILLED: null,
  CREATE_DOCUMENT_REJECTED: null,
  CANCEL_NOTE_EDIT: null,
  SET_EDITING_NOTE: null,
  SAVE_S2K_REQUESTED: null,
  SAVE_S2K_FULFILLED: null,
  SAVE_S2K_REJECTED: null,
  SET_ORDERS: null,
  // USER
  GET_USER_REQUESTED: null,
  GET_USER_FULFILLED: null,
  GET_USER_REJECTED: null,
  CREATE_USER_REQUESTED: null,
  CREATE_USER_FULFILLED: null,
  CREATE_USER_REJECTED: null,
  UPDATE_USER_REQUESTED: null,
  UPDATE_USER_FULFILLED: null,
  UPDATE_USER_REJECTED: null,
  DELETE_USER_REQUESTED: null,
  DELETE_USER_FULFILLED: null,
  DELETE_USER_REJECTED: null,
  LOGIN_USER_REQUESTED: null,
  LOGIN_USER_FULFILLED: null,
  LOGIN_USER_REJECTED: null,
  LOGOUT_USER_REQUESTED: null,
  LOGOUT_USER_FULFILLED: null,
  LOGOUT_USER_REJECTED: null,
  FORGOT_PASSWORD_USER_REQUESTED: null,
  FORGOT_PASSWORD_USER_FULFILLED: null,
  FORGOT_PASSWORD_USER_REJECTED: null,
  VERIFY_USER_REQUESTED: null,
  VERIFY_USER_FULFILLED: null,
  VERIFY_USER_REJECTED: null,
  VALIDATE_USER_REQUESTED: null,
  VALIDATE_USER_FULFILLED: null,
  VALIDATE_USER_REJECTED: null,
  RESEND_CODE_REQUESTED: null,
  RESEND_CODE_FULFILLED: null,
  RESEND_CODE_REJECTED: null,
  CHANGE_PASSWORD_USER_REQUESTED: null,
  CHANGE_PASSWORD_USER_FULFILLED: null,
  CHANGE_PASSWORD_USER_REJECTED: null,
  VERIFY_TOKEN_USER_REQUESTED: null,
  VERIFY_TOKEN_USER_FULFILLED: null,
  VERIFY_TOKEN_USER_REJECTED: null,
  RESET_USER_STATE: null,
  // SYNOPSIS
  SHOW_SYNOPSIS: null,
  SET_YEARS: null
})
